import { useMutation, useQueryClient } from "react-query";
import { ECoursesQueryKeys } from "api/endpoints/courses";
import { addCourseLessonToStudent } from "api/services/courses";
import { logError } from "utils/notifications";
import { TAddCourseLessonToStudentBody } from "types/api/course";
import { TApiError } from "types/api/error";

export const useAddCourseLessonToStudent = () => {
  const queryClient = useQueryClient();
  return useMutation<void, TApiError, TAddCourseLessonToStudentBody>(
    addCourseLessonToStudent,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(ECoursesQueryKeys.getAllCourseLessons);
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
